import { useContext } from "react";

import { ISavedFilterItem, LocalFilterContext, LocalFilterValueType } from "@/shared/contexts";

export const useLocalFilter = (): {
    localFilters: ISavedFilterItem[];
    updateFilter: (id: string, values: LocalFilterValueType) => void;
    isFilterApplied: (id: string) => boolean;
    getFilterValue: (id: string) => LocalFilterValueType;
    removeFilter: (id: string) => void;
    removeAll: () => void;
} => {
    const context = useContext(LocalFilterContext);
    return {
        localFilters: context.localFilters,
        isFilterApplied: context.isFilterApplied,
        getFilterValue: context.getFilterValue,
        updateFilter: context.updateFilter,
        removeFilter: context.removeFilter,
        removeAll: context.removeAll,
    };
};
